import styled from "styled-components";
const BadgeComponent = styled("div")(
  ({ borderThickness, bigosity, theme }) => ({
    backgroundClip: "content-box",
    backgroundColor: theme.color.red6,
    border: `${borderThickness}px solid transparent`,
    borderRadius: "50%",
    boxSizing: "border-box",
    color: "rgba(255, 255, 255, 0.85)",
    fontFamily: theme.fontFamily.default,
    fontSize: 8,
    fontVariantNumeric: "normal",
    fontWeight: theme.fontWeight.semiBold,
    height: bigosity,
    lineHeight: `14px`,
    textAlign: "center",
    width: bigosity
  })
);
export {
  BadgeComponent
};
